export const generateDate = () => {
    const currentDate = new Date();

    const year = currentDate.getFullYear();
    const mount = ("0" + (currentDate.getMonth() + 1)).slice(-2);
    const day = ("0" + currentDate.getDate()).slice(-2);

    return `${year}-${mount}-${day}`;
}